import { render, staticRenderFns } from "./AccountDemande.vue?vue&type=template&id=4e85429f&scoped=true"
import script from "./AccountDemande.vue?vue&type=script&lang=js"
export * from "./AccountDemande.vue?vue&type=script&lang=js"
import style0 from "./AccountDemande.vue?vue&type=style&index=0&id=4e85429f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e85429f",
  null
  
)

export default component.exports